import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

const iconStyle = {
  width: "1rem",
  height: "1rem",
  marginRight: "0.25rem",
};

function CalendarCollapseToggle({ collapsed, onToggle }) {
  const { t } = useTranslation("athlete-portal");

  return (
    <div className="calendar-view-toolbar">
      <button
        type="button"
        className={`calendar-collapse-toggle${collapsed ? " active" : ""}`}
        onClick={onToggle}
      >
        <SvgIcon
          src={
            collapsed
              ? "/img/new-icons/align-vertical-space-around.svg"
              : "/img/new-icons/panel-top-close.svg"
          }
          useCurrentColor={true}
          style={iconStyle}
        />
        {collapsed
          ? t("calendar.expand", "Align rows")
          : t("calendar.collapse", "Collapse")}
      </button>
    </div>
  );
}

export default CalendarCollapseToggle;
